export default __webpack_public_path__ + "static/media/500.5bd72fe7.svg";